/**
 * @generated SignedSource<<fcc85c06f8aa58c0d6340f9dcd620d24>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type IntegrationType = "AWS" | "BITBUCKET" | "BUILDKITE" | "CAPABILITIES" | "CLOUDWATCH" | "CONFLUENCE" | "CURSOR" | "DATADOG" | "DEVIN" | "DISCORD" | "ELASTICSEARCH" | "FIREHYDRANT" | "GCP" | "GCP_CLOUD_MONITORING" | "GITHUB" | "GITLAB" | "GRAFANA_CLOUD" | "INCIDENT_IO" | "JIRA" | "LANGFUSE" | "LANGSMITH" | "LINEAR" | "NEW_RELIC" | "NOTION" | "OPENSEARCH" | "OPSGENIE" | "PAGERDUTY" | "PGANALYZE" | "POSTGRESQL" | "PROMETHEUS" | "ROLLBAR" | "ROOTLY" | "SENTRY" | "SLACK" | "SNOWFLAKE" | "SOCKET" | "TEMPORAL" | "%future added value";
export type ValidateIntegrationInput = {
  credentials: string;
  integrationId?: any | null | undefined;
  integrationType: IntegrationType;
};
export type TemporalIntegrationFormValidateIntegrationMutation$variables = {
  input: ValidateIntegrationInput;
};
export type TemporalIntegrationFormValidateIntegrationMutation$data = {
  readonly validateIntegration: {
    readonly error: string | null | undefined;
    readonly success: boolean;
  };
};
export type TemporalIntegrationFormValidateIntegrationMutation = {
  response: TemporalIntegrationFormValidateIntegrationMutation$data;
  variables: TemporalIntegrationFormValidateIntegrationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ValidateIntegrationPayload",
    "kind": "LinkedField",
    "name": "validateIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TemporalIntegrationFormValidateIntegrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TemporalIntegrationFormValidateIntegrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "54487d3ddd5c557c5b5590a166980caa",
    "id": null,
    "metadata": {},
    "name": "TemporalIntegrationFormValidateIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation TemporalIntegrationFormValidateIntegrationMutation(\n  $input: ValidateIntegrationInput!\n) {\n  validateIntegration(input: $input) {\n    success\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "12933bdd3b853c4beb7673dcc4522e45";

export default node;
